import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";

import {
  Stack,
  CardActions,
  CardContent,
  Typography,
  Modal,
  Card,
  TableContainer,
  TableBody,
  TableCell,
  TableRow,
  Table,
  OutlinedInput,
  InputAdornment,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Alert,
  Tooltip,
} from "@mui/material";
import { styled } from "@mui/system";

import courtesyService from "../services/CourtesyService";
import Scrollbar from "../../../../components/Scrollbar";
import TagsListHead from "../../tags/components/TagsListHead";
import { Icon } from "@iconify/react";
import searchFill from "@iconify/icons-eva/search-fill";
const TABLE_HEAD_SEND = [
  { id: "data", label: "Data", alignRight: false },
  { id: "name_Lens", label: "Tratamento", alignRight: false },
  { id: "totalCourtesy", label: "Total ", alignRight: false },
  { id: "type", label: "Tipo", alignRight: false },
  { id: "obs", label: "Observação", alignRight: false },
  { id: "approvedCourtesy", label: "Utilizadas", alignRight: false },
  { id: "disabledCourtesy", label: "Desativadas", alignRight: false },
  { id: "availableCourtesy", label: "Disponíveis", alignRight: false },
  { id: "actions", label: "Ações", alignRight: false },
];

const TABLE_HEAD = [
  { id: "name_Lens", label: "Tratamento", alignRight: false },

  { id: "totalCourtesy", label: "Total ", alignRight: false },
  { id: "approvedCourtesy", label: "Total utilizada", alignRight: false },
];

const TABLE_HEAD2 = [
  { id: "updated_at", label: "Data", alignRight: false },
  { id: "code_Order", label: "Codigo", alignRight: false },
  { id: "name_Lens", label: "Tratamento", alignRight: false },
];

const SearchStyle = styled(OutlinedInput)(({ theme }: any) => ({
  height: 48,
  float: "left",
  borderRadius: "40px",
  backgroundColor: "#fff",
  transition: theme.transitions.create(["box-shadow", "width"], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  "&.Mui-focused": { boxShadow: theme.customShadows.z8 },
  "& fieldset": {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}));
interface ModalProps {
  title: string;
  open: boolean;
  handler: () => void;
  setError: () => void;
  setSuccess: () => void;
  confirmButtonText: string;
  data: any;
  type: string;
}

export default function CourtesyModalClient(props: ModalProps) {
  const [data, setData]: any = useState([]);
  const [filterName, setFilterName]: any = useState("");
  const [filterParams, setFilterParams]: any = useState("");
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedCourtesyList, setSelectedCourtesyList]: any = useState(null);
  const [quantityToDeactivate, setQuantityToDeactivate] = useState("");
  const [deactivationReason, setDeactivationReason] = useState("");
  const [deactivationError, setDeactivationError] = useState("");
  const [isDeactivating, setIsDeactivating] = useState(false);
  const [historyCourtesyList, setHistoryCourtesyList]: any = useState(null);
  const [deactivationHistory, setDeactivationHistory]: any = useState([]);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);

  useEffect(() => {
    courtesyService
      .getClient(props.data.id_Customer, props.type, filterParams)
      .then((data: any) => setData(data.data))
      .catch((error: any) => console.error(error));
  }, [props.data, props.type, filterParams, refreshKey]);

  const searchSubmit = () => {
    setFilterParams(filterName);
  };

  const closeDeactivationDialog = () => {
    setSelectedCourtesyList(null);
    setQuantityToDeactivate("");
    setDeactivationReason("");
    setDeactivationError("");
  };

  const deactivateCourtesies = async () => {
    const quantity = Number(quantityToDeactivate);
    const available = Number(selectedCourtesyList?.availableCourtesy || 0);
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > available) {
      setDeactivationError(`Informe uma quantidade entre 1 e ${available}.`);
      return;
    }

    try {
      setIsDeactivating(true);
      await courtesyService.deactivate(
        selectedCourtesyList.id,
        quantity,
        deactivationReason
      );
      closeDeactivationDialog();
      setRefreshKey((value: number) => value + 1);
      props.setSuccess();
    } catch (error: any) {
      setDeactivationError(
        error?.response?.data?.message || "Não foi possível desativar as cortesias."
      );
    } finally {
      setIsDeactivating(false);
    }
  };

  const openDeactivationHistory = async (courtesyList: any) => {
    setHistoryCourtesyList(courtesyList);
    setIsLoadingHistory(true);
    try {
      const response = await courtesyService.getDeactivationHistory(courtesyList.id);
      setDeactivationHistory(response.data);
    } catch (error) {
      setDeactivationHistory([]);
    } finally {
      setIsLoadingHistory(false);
    }
  };

  return (
    <>
      <Modal
        open={props.open}
        onClose={() => {
          props.handler();
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <>
          <Card
            sx={{
              width: "min(calc(100vw - 48px), 1560px)",
              minWidth: 0,
              maxHeight: "86vh",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
              {props.type === "send" && (
                <>
                  <Stack direction="column" mb={3} spacing={1}>
                    <Typography variant="h4" color="#004A78" gutterBottom>
                      Cortesias
                    </Typography>
                    <Stack direction="row" spacing={2}>
                      <SearchStyle
                        sx={{
                          width: ["100%", 350],
                        }}
                        value={filterName}
                        onChange={(e: any) => setFilterName(e.target.value)}
                        placeholder="Pesquisar..."
                        inputProps={{ style: { textTransform: "uppercase" } }}
                        startAdornment={
                          <InputAdornment position="start">
                            <Box
                              component={Icon}
                              icon={searchFill}
                              sx={{ color: "text.disabled" }}
                            />
                          </InputAdornment>
                        }
                      />
                      <Button
                        sx={{
                          height: "48px",
                          borderRadius: "40px",
                          background: "#004A78",

                          "&:hover": {
                            bgcolor: "#226C9A",
                          },
                        }}
                        variant="contained"
                        onClick={searchSubmit}
                        color="secondary"
                      >
                        Pesquisar
                      </Button>
                    </Stack>
                  </Stack>

                  <Card sx={{ overflow: "hidden" }}>
                    <Scrollbar>
                      <TableContainer sx={{ overflowX: "auto" }}>
                        <Table sx={{ minWidth: 1325, tableLayout: "fixed" }}>
                          <colgroup>
                            <col style={{ width: "150px" }} />
                            <col style={{ width: "190px" }} />
                            <col style={{ width: "65px" }} />
                            <col style={{ width: "100px" }} />
                            <col style={{ width: "330px" }} />
                            <col style={{ width: "95px" }} />
                            <col style={{ width: "105px" }} />
                            <col style={{ width: "100px" }} />
                            <col style={{ width: "190px" }} />
                          </colgroup>
                          <TagsListHead headLabel={TABLE_HEAD_SEND} />
                          <TableBody>
                            {data?.length ? (
                              data?.map((row: any, index: any) => {
                                const {
                                  updated_at_formatted,
                                  name_Lens,
                                  num_courtesies,
                                  observation,
                                  type,
                                  approvedCourtesy,
                                  disabledCourtesy,
                                  availableCourtesy,
                                } = row;
                                const total = Number(num_courtesies || 0);
                                const used = Number(approvedCourtesy || 0);
                                const disabled = Number(disabledCourtesy || 0);
                                const available = Number.isFinite(Number(availableCourtesy))
                                  ? Number(availableCourtesy)
                                  : Math.max(0, total - used - disabled);

                                return (
                                  <TableRow
                                    hover
                                    tabIndex={-1}
                                    role="checkbox"
                                    key={index}
                                  >
                                    <TableCell align="left">
                                      <Tooltip title={updated_at_formatted} arrow placement="top">
                                        <Typography
                                          variant="subtitle2"
                                          noWrap
                                          sx={{
                                            color: "#004A78",
                                            fontSize: "14px",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          }}
                                        >
                                          {updated_at_formatted}
                                        </Typography>
                                      </Tooltip>
                                    </TableCell>
                                    <TableCell align="left">
                                      <Tooltip title={name_Lens} arrow placement="top">
                                        <Typography
                                          variant="subtitle2"
                                          noWrap
                                          sx={{
                                            color: "#004A78",
                                            fontSize: "14px",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          }}
                                        >
                                          {name_Lens}
                                        </Typography>
                                      </Tooltip>
                                    </TableCell>

                                    <TableCell align="left">
                                      <Typography
                                        variant="subtitle2"
                                        noWrap
                                        sx={{
                                          color: "#004A78",
                                          fontSize: "14px",
                                        }}
                                      >
                                        {num_courtesies}
                                      </Typography>
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography
                                        variant="subtitle2"
                                        noWrap
                                        sx={{
                                          color: "#004A78",
                                          fontSize: "14px",
                                        }}
                                      >
                                        {type}
                                      </Typography>
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      sx={{
                                        whiteSpace: "normal",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      <Tooltip title={observation || "Sem observação"} arrow placement="top">
                                        <Typography
                                          variant="subtitle2"
                                          sx={{
                                            color: "#004A78",
                                            fontSize: "14px",
                                            lineHeight: 1.35,
                                            overflowWrap: "anywhere",
                                            display: "-webkit-box",
                                            WebkitBoxOrient: "vertical",
                                            WebkitLineClamp: 2,
                                            overflow: "hidden",
                                          }}
                                        >
                                          {observation || "—"}
                                        </Typography>
                                      </Tooltip>
                                    </TableCell>
                                    <TableCell align="left">{used}</TableCell>
                                    <TableCell align="left">{disabled}</TableCell>
                                    <TableCell align="left">{available}</TableCell>
                                    <TableCell align="left" sx={{ pr: 2 }}>
                                      <Stack
                                        direction="row"
                                        spacing={0.75}
                                        alignItems="center"
                                        sx={{ whiteSpace: "nowrap" }}
                                      >
                                        <Button
                                          size="small"
                                          variant="outlined"
                                          sx={{
                                            minWidth: 82,
                                            color: "#C62828",
                                            borderColor: "#C62828",
                                            "&:hover": {
                                              color: "#A51D1D",
                                              borderColor: "#A51D1D",
                                              backgroundColor: "rgba(198, 40, 40, 0.04)",
                                            },
                                          }}
                                          disabled={available === 0}
                                          onClick={() => {
                                            setSelectedCourtesyList({
                                              ...row,
                                              availableCourtesy: available,
                                            });
                                            setDeactivationError("");
                                          }}
                                        >
                                          Desativar
                                        </Button>
                                        {disabled > 0 && (
                                          <Button
                                            size="small"
                                            sx={{
                                              minWidth: 76,
                                              color: "#004A78",
                                              "&:hover": {
                                                color: "#226C9A",
                                                backgroundColor: "rgba(0, 74, 120, 0.04)",
                                              },
                                            }}
                                            onClick={() => openDeactivationHistory(row)}
                                          >
                                            Histórico
                                          </Button>
                                        )}
                                      </Stack>
                                    </TableCell>
                                  </TableRow>
                                );
                              })
                            ) : (
                              <TableRow>
                                <TableCell
                                  align="center"
                                  colSpan={7}
                                  sx={{ py: 3 }}
                                >
                                  <Stack
                                    width="100%"
                                    justifyContent="center"
                                    alignItems="center"
                                  >
                                    <Typography
                                      mt={1}
                                      variant="body1"
                                      noWrap
                                      sx={{ color: "#909090" }}
                                    >
                                      Nenhum item encontrado...
                                    </Typography>
                                  </Stack>
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Scrollbar>
                  </Card>
                </>
              )}

              {props.type === "historic" && (
                <>
                  <Typography variant="h4" my={4} color="#004A78" gutterBottom>
                    Cortesias Utilizadas
                  </Typography>
                  <Card>
                    <Scrollbar>
                      <TableContainer>
                        <Table>
                          <TagsListHead headLabel={TABLE_HEAD2} />
                          <TableBody>
                            {data?.length ? (
                              data?.map((row: any, index: any) => {
                                const {
                                  name_Lens,

                                  updated_at_formatted,
                                  code_Order,
                                } = row;

                                return (
                                  <TableRow
                                    hover
                                    tabIndex={-1}
                                    role="checkbox"
                                    key={index}
                                  >
                                    <TableCell align="left">
                                      <Typography
                                        variant="subtitle2"
                                        noWrap
                                        sx={{
                                          color: "#004A78",
                                          fontSize: "14px",
                                        }}
                                      >
                                        {updated_at_formatted}
                                      </Typography>
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography
                                        variant="subtitle2"
                                        noWrap
                                        sx={{
                                          color: "#004A78",
                                          fontSize: "14px",
                                        }}
                                      >
                                        {code_Order}
                                      </Typography>
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography
                                        variant="subtitle2"
                                        noWrap
                                        sx={{
                                          color: "#004A78",
                                          fontSize: "14px",
                                        }}
                                      >
                                        {name_Lens}
                                      </Typography>
                                    </TableCell>
                                  </TableRow>
                                );
                              })
                            ) : (
                              <TableRow>
                                <TableCell
                                  align="center"
                                  colSpan={7}
                                  sx={{ py: 3 }}
                                >
                                  <Stack
                                    width="100%"
                                    justifyContent="center"
                                    alignItems="center"
                                  >
                                    <Typography
                                      mt={1}
                                      variant="body1"
                                      noWrap
                                      sx={{ color: "#909090" }}
                                    >
                                      Nenhum item encontrado...
                                    </Typography>
                                  </Stack>
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Scrollbar>
                  </Card>
                </>
              )}
              {props.type === "more" && (
                <>
                  <Typography
                    variant="h4"
                    marginBottom={4}
                    color="#004A78"
                    gutterBottom
                  >
                    Cortesias
                  </Typography>
                  <Card>
                    <Scrollbar>
                      <TableContainer>
                        <Table>
                          <TagsListHead headLabel={TABLE_HEAD} />
                          <TableBody>
                            {data?.length ? (
                              data?.map((row: any, index: any) => {
                                const {
                                  name_Lens,

                                  approvedCourtesy,
                                  totalCourtesy,
                                } = row;

                                return (
                                  <TableRow
                                    hover
                                    tabIndex={-1}
                                    role="checkbox"
                                    key={index}
                                  >
                                    <TableCell align="left">
                                      <Typography
                                        variant="subtitle2"
                                        noWrap
                                        sx={{
                                          color: "#004A78",
                                          fontSize: "14px",
                                        }}
                                      >
                                        {name_Lens}
                                      </Typography>
                                    </TableCell>

                                    <TableCell align="left">
                                      <Typography
                                        variant="subtitle2"
                                        noWrap
                                        sx={{
                                          color: "#004A78",
                                          fontSize: "14px",
                                        }}
                                      >
                                        {totalCourtesy}
                                      </Typography>
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography
                                        variant="subtitle2"
                                        noWrap
                                        sx={{
                                          color: "#004A78",
                                          fontSize: "14px",
                                        }}
                                      >
                                        {approvedCourtesy}
                                      </Typography>
                                    </TableCell>
                                  </TableRow>
                                );
                              })
                            ) : (
                              <TableRow>
                                <TableCell
                                  align="center"
                                  colSpan={7}
                                  sx={{ py: 3 }}
                                >
                                  <Stack
                                    width="100%"
                                    justifyContent="center"
                                    alignItems="center"
                                  >
                                    <Typography
                                      mt={1}
                                      variant="body1"
                                      noWrap
                                      sx={{ color: "#909090" }}
                                    >
                                      Nenhum item encontrado...
                                    </Typography>
                                  </Stack>
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Scrollbar>
                  </Card>
                </>
              )}
            </CardContent>
            <CardActions sx={{ flexShrink: 0, px: 2, pb: 2 }}>
              <LoadingButton
                fullWidth
                type="submit"
                variant="contained"
                onClick={() => props.handler()}
                sx={{
                  m: 1,
                  height: "48px",
                  borderRadius: "30px",
                  backgroundColor: "#CDCDCD",
                  color: "#004A78",
                  "&:hover": {
                    bgcolor: "#004A78",
                    color: "#FEFEFE",
                  },
                }}
                autoFocus
              >
                Fechar
              </LoadingButton>
            </CardActions>
          </Card>
          <Dialog
            open={Boolean(selectedCourtesyList)}
            onClose={isDeactivating ? undefined : closeDeactivationDialog}
            fullWidth
            maxWidth="xs"
          >
            <DialogTitle>Desativar cortesias do lote</DialogTitle>
            <DialogContent>
              <Typography variant="body2" sx={{ mb: 2 }}>
                Há {selectedCourtesyList?.availableCourtesy || 0} cortesias disponíveis neste lote.
                Cortesias já utilizadas não serão alteradas.
              </Typography>
              {deactivationError && <Alert severity="error" sx={{ mb: 2 }}>{deactivationError}</Alert>}
              <TextField
                autoFocus
                fullWidth
                type="number"
                label="Quantidade a desativar"
                inputProps={{ min: 1, max: selectedCourtesyList?.availableCourtesy || 0 }}
                value={quantityToDeactivate}
                onChange={(event) => setQuantityToDeactivate(event.target.value)}
                sx={{
                  "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                    borderColor: "#004A78",
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#004A78",
                  },
                }}
              />
              <TextField
                fullWidth
                multiline
                minRows={2}
                label="Motivo (opcional)"
                value={deactivationReason}
                onChange={(event) => setDeactivationReason(event.target.value)}
                sx={{
                  mt: 2,
                  "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                    borderColor: "#004A78",
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#004A78",
                  },
                }}
              />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={closeDeactivationDialog}
                disabled={isDeactivating}
                sx={{ color: "#004A78" }}
              >
                Cancelar
              </Button>
              <LoadingButton
                onClick={deactivateCourtesies}
                loading={isDeactivating}
                variant="contained"
                sx={{
                  backgroundColor: "#C62828",
                  "&:hover": { backgroundColor: "#A51D1D" },
                }}
              >
                Desativar
              </LoadingButton>
            </DialogActions>
          </Dialog>
          <Dialog
            open={Boolean(historyCourtesyList)}
            onClose={() => setHistoryCourtesyList(null)}
            fullWidth
            maxWidth="md"
          >
            <DialogTitle>Histórico de desativações</DialogTitle>
            <DialogContent>
              {isLoadingHistory ? (
                <Typography>Carregando histórico...</Typography>
              ) : deactivationHistory.length ? (
                <Table size="small">
                  <TagsListHead
                    headLabel={[
                      { id: "disabled_at", label: "Data", alignRight: false },
                      { id: "quantity", label: "Quantidade", alignRight: false },
                      { id: "disabled_by_name", label: "Desativado por", alignRight: false },
                      { id: "disabled_reason", label: "Motivo", alignRight: false },
                    ]}
                  />
                  <TableBody>
                    {deactivationHistory.map((item: any, index: number) => (
                      <TableRow key={index}>
                        <TableCell>{item.disabled_at_formatted}</TableCell>
                        <TableCell>{item.quantity}</TableCell>
                        <TableCell>{item.disabled_by_name || "Usuário não identificado"}</TableCell>
                        <TableCell>{item.disabled_reason || "Não informado"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <Typography>Nenhuma desativação registrada neste lote.</Typography>
              )}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setHistoryCourtesyList(null)}
                sx={{ color: "#004A78" }}
              >
                Fechar
              </Button>
            </DialogActions>
          </Dialog>
        </>
      </Modal>
    </>
  );
}
